module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-29_APRILE-OK-small-38715b0e7e20bb25042c3908a96f03af.png";